import Api from './ApiWAService'

export default {
    get(keyword, pageNumber, pageSize, order, status = '', category = '') {
        let url = `whatsapp_message_template?keyword=${encodeURIComponent(keyword)}&pageNumber=${pageNumber}&pageSize=${pageSize}&orderColumn=${order.column}&orderSort=${order.sort}`;
        if (status) url += `&status=${status}`;
        if (category) url += `&category=${category}`;
        return Api().get(url);
    },
    getOne(id) {
        return Api().get(`whatsapp_message_template/${id}`);
    },
    // Catálogo das variáveis locais (camada única: nome do aluno, e-mail...)
    variables() {
        return Api().get(`whatsapp_message_template/variables`);
    },
    // Mídia de exemplo p/ cabeçalho IMAGE/VIDEO/DOCUMENT → { handle, format, previewUrl }
    uploadSample(file) {
        const formData = new FormData();
        formData.append('media', file);
        return Api().post(`whatsapp_message_template/upload-sample`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    },
    // Sincroniza os templates da conta Meta (WABA) do tenant para o cache local
    sync() {
        return Api().post(`whatsapp_message_template/sync`);
    },
    // Pré-valida os valores preenchidos contra a estrutura do template
    validate(templateId, values) {
        return Api().post(`whatsapp_message_template/validate`, { templateId, values });
    },
    // CRUD na Meta (o cache local acompanha; aprovação chega via webhook).
    // update() com SÓ { variable_map } salva localmente sem reenviar à Meta.
    create(payload) {
        return Api().post(`whatsapp_message_template`, payload);
    },
    update(id, payload) {
        return Api().put(`whatsapp_message_template/${id}`, payload);
    },
    remove(id) {
        return Api().delete(`whatsapp_message_template/${id}`);
    }
}
